import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EulaService {

  readonly url: string = 'eula';
	constructor(private http: HttpClient) {}

  public hasUserAcceptedEula(): Observable<boolean>  {
		return this.http.get<boolean>(this.url + '/hasUserAcceptedEula');
	}

  public acceptEula() {
    return this.http.post(this.url + '/acceptEula', {});
  }

}
